export default __webpack_public_path__ + "static/media/user.732d6cab.svg";